// eslint-disable-next-line no-unused-vars
var itemsEs = {
    "1": "Master Ball",
    "2": "Ultra Ball",
    "3": "Super Ball",
    "4": "Poké Ball",
    "5": "Safari Ball",
    "6": "Malla Ball",
    "7": "Buceo Ball",
    "8": "Nido Ball",
    "9": "Acopio Ball",
    "10": "Turno Ball",
    "11": "Lujo Ball",
    "12": "Honor Ball",
    "13": "Ocaso Ball",
    "14": "Sana Ball",
    "15": "Veloz Ball",
    "16": "Gloria Ball",
    "17": "Poción",
    "18": "Antídoto",
    "19": "Antiquemar",
    "20": "Antihielo",
    "21": "Despertar",
    "22": "Antiparalizador",
    "23": "Restaurar Todo",
    "24": "Poción Máxima",
    "25": "Hiperpoción",
    "26": "Superpoción",
    "27": "Cura Total",
    "28": "Revivir",
    "29": "Revivir Máximo",
    "30": "Agua Fresca",
    "31": "Refresco",
    "32": "Limonada",
    "33": "Leche Mu-mu",
    "34": "Polvo Energía",
    "35": "Raíz Energía",
    "36": "Polvo Curación",
    "37": "Hierba Revivir",
    "38": "Éter",
    "39": "Éter Máximo",
    "40": "Elixir",
    "41": "Elixir Máximo",
    "42": "Galleta Lava",
    "43": "Zumo de Baya",
    "44": "Ceniza Sagrada",
    "45": "Más PS",
    "46": "Proteína",
    "47": "Hierro",
    "48": "Carburante",
    "49": "Calcio",
    "50": "Caramelo Raro",
    "51": "Más PP",
    "52": "Zinc",
    "53": "PP Máximos",
    "54": "Barrita Plus",
    "55": "Protección X",
    "56": "Crítico X",
    "57": "Ataque X",
    "58": "Defensa X",
    "59": "Velocidad X",
    "60": "Precisión X",
    "61": "Ataque Especial X",
    "62": "Defensa Especial X",
    "63": "Pokémuñeco",
    "64": "Cola Skitty",
    "65": "Flauta Azul",
    "66": "Flauta Amarilla",
    "67": "Flauta Roja",
    "68": "Flauta Negra",
    "69": "Flauta Blanca",
    "70": "Sal Cardumen",
    "71": "Concha Cardumen",
    "72": "Parte Roja",
    "73": "Parte Azul",
    "74": "Parte Amarilla",
    "75": "Parte Verde",
    "76": "Superrepelente",
    "77": "Repelente Máximo",
    "79": "Repelente",
    "80": "Piedra Solar",
    "81": "Piedra Lunar",
    "82": "Piedra Fuego",
    "83": "Piedra Trueno",
    "84": "Piedra Agua",
    "85": "Piedra Hoja",
    "86": "Miniseta",
    "87": "Seta Grande",
    "88": "Perla",
    "89": "Perla Grande",
    "90": "Polvo Estelar",
    "91": "Trozo Estrella",
    "92": "Pepita",
    "93": "Escama Corazón",
    "94": "Miel",
    "95": "Abono Rápido",
    "96": "Abono Lento",
    "97": "Abono Fijador",
    "98": "Abono Brote",
    "99": "Fósil Raíz",
    "100": "Fósil Garra",
    "101": "Fósil Hélix",
    "102": "Fósil Domo",
    "103": "Ámbar Viejo",
    "104": "Fósil Coraza",
    "105": "Fósil Cráneo",
    "106": "Hueso Raro",
    "107": "Piedra Día",
    "108": "Piedra Noche",
    "109": "Piedra Alba",
    "110": "Piedra Oval",
    "111": "Piedra Espíritu",
    "112": "Griseosfera",
    "116": "HidroROM",
    "117": "FulgoROM",
    "118": "PiroROM",
    "119": "CrioROM",
    "120": "(?)",
    "129": "(?)",
    "130": "(?)",
    "131": "(?)",
    "132": "(?)",
    "133": "(?)",
    "134": "Corazón Dulce",
    "135": "Diamansfera",
    "136": "Lustresfera",
    "137": "Carta Inicial",
    "138": "Carta Favoritos",
    "139": "Carta Invitar",
    "140": "Carta Gracias",
    "141": "Carta Pregunta",
    "142": "Carta Gustos",
    "143": "Carta Respuesta",
    "144": "Carta Puente S",
    "145": "Carta Puente F",
    "146": "Carta Puente A",
    "147": "Carta Puente V",
    "148": "Carta Puente P",
    "149": "Baya Zreza",
    "150": "Baya Atania",
    "151": "Baya Meloc",
    "152": "Baya Safre",
    "153": "Baya Perasi",
    "154": "Baya Zanama",
    "155": "Baya Aranja",
    "156": "Baya Caquic",
    "157": "Baya Ziuela",
    "158": "Baya Zidra",
    "159": "Baya Higog",
    "160": "Baya Wiki",
    "161": "Baya Ango",
    "162": "Baya Guaya",
    "163": "Baya Pabaya",
    "164": "Baya Frambu",
    "165": "Baya Oram",
    "166": "Baya Latano",
    "167": "Baya Peragu",
    "168": "Baya Pinia",
    "169": "Baya Grana",
    "170": "Baya Algama",
    "171": "Baya Ispero",
    "172": "Baya Meluce",
    "173": "Baya Uvav",
    "174": "Baya Tamate",
    "175": "Baya Mais",
    "176": "Baya Aostan",
    "177": "Baya Rautan",
    "178": "Baya Monli",
    "179": "Baya Wikano",
    "180": "Baya Plama",
    "181": "Baya Sambia",
    "182": "Baya Rudion",
    "183": "Baya Andano",
    "184": "Baya Caoca",
    "185": "Baya Pasio",
    "186": "Baya Gualot",
    "187": "Baya Tamar",
    "188": "Baya Rimoya",
    "189": "Baya Pomaro",
    "190": "Baya Kebia",
    "191": "Baya Acardo",
    "192": "Baya Kouba",
    "193": "Baya Payapa",
    "194": "Baya Yecana",
    "195": "Baya Alcho",
    "196": "Baya Drasi",
    "197": "Baya Anjiro",
    "198": "Baya Dillo",
    "199": "Baya Baribá",
    "200": "Baya Chilan",
    "201": "Baya Lichi",
    "202": "Baya Gonlan",
    "203": "Baya Aslac",
    "204": "Baya Yapati",
    "205": "Baya Aricoc",
    "206": "Baya Zonlan",
    "207": "Baya Arabol",
    "208": "Baya Enigma",
    "209": "Baya Lagro",
    "210": "Baya Chiri",
    "211": "Baya Jaboca",
    "212": "Baya Magua",
    "213": "Polvo Brillo",
    "214": "Hierba Blanca",
    "215": "Brazal Firme",
    "217": "Garra Rápida",
    "218": "Cascabel Alivio",
    "219": "Hierba Mental",
    "220": "Cinta Elección",
    "221": "Roca del Rey",
    "222": "Polvo Plata",
    "223": "Moneda Amuleto",
    "224": "Amuleto",
    "225": "Rocío Bondad",
    "226": "Diente Marino",
    "227": "Escama Marina",
    "228": "Bola de Humo",
    "229": "Piedra Eterna",
    "230": "Cinta Aguante",
    "231": "Huevo Suerte",
    "232": "Periscopio",
    "233": "Revest. Metálico",
    "234": "Restos",
    "235": "Escama Dragón",
    "236": "Bola Luminosa",
    "237": "Arena Fina",
    "238": "Piedra Dura",
    "239": "Semilla Milagro",
    "240": "Gafas de Sol",
    "241": "Cinturón Negro",
    "242": "Imán",
    "243": "Agua Mística",
    "244": "Pico Afilado",
    "245": "Flecha Venenosa",
    "246": "Antiderretir",
    "247": "Hechizo",
    "248": "Cuchara Torcida",
    "249": "Carbón",
    "250": "Colmillo Dragón",
    "251": "Pañuelo de Seda",
    "252": "Mejora",
    "253": "Cascabel Concha",
    "254": "Incienso Marino",
    "255": "Incienso Suave",
    "256": "Puño Suerte",
    "257": "Polvo Metálico",
    "258": "Hueso Grueso",
    "259": "Puerro",
    "260": "Pañuelo Rojo",
    "261": "Pañuelo Azul",
    "262": "Pañuelo Rosa",
    "263": "Pañuelo Verde",
    "264": "Pañuelo Amarillo",
    "265": "Lupa",
    "266": "Cinta Fuerte",
    "267": "Gafas Especiales",
    "268": "Cinta Experto",
    "269": "Refleluz",
    "270": "Vidasfera",
    "271": "Hierba Única",
    "272": "Toxisfera",
    "273": "Llamasfera",
    "274": "Polvo Veloz",
    "275": "Banda Aguante",
    "276": "Telescopio",
    "277": "Metrónomo",
    "278": "Bola Férrea",
    "279": "Cola Plúmbea",
    "280": "Lazo Destino",
    "281": "Lodo Negro",
    "282": "Roca Helada",
    "283": "Roca Suave",
    "284": "Roca Calor",
    "285": "Roca Lluvia",
    "286": "Garra Garfio",
    "287": "Pañuelo Elección",
    "288": "Toxiestrella",
    "289": "Brazal Recio",
    "290": "Cinto Recio",
    "291": "Lente Recia",
    "292": "Banda Recia",
    "293": "Franja Recia",
    "294": "Pesa Recia",
    "295": "Muda Concha",
    "296": "Raíz Grande",
    "297": "Gafas Elección",
    "298": "Tabla Llama",
    "299": "Tabla Linfa",
    "300": "Tabla Trueno",
    "301": "Tabla Pradal",
    "302": "Tabla Helada",
    "303": "Tabla Fuerte",
    "304": "Tabla Tóxica",
    "305": "Tabla Terrax",
    "306": "Tabla Cielo",
    "307": "Tabla Mental",
    "308": "Tabla Bicho",
    "309": "Tabla Pétrea",
    "310": "Tabla Terror",
    "311": "Tabla Draco",
    "312": "Tabla Oscura",
    "313": "Tabla Acero",
    "314": "Incienso Raro",
    "315": "Incienso Roca",
    "316": "Incienso Lento",
    "317": "Incienso Acua",
    "318": "Incienso Floral",
    "319": "Incienso Duplo",
    "320": "Incienso Puro",
    "321": "Protector",
    "322": "Electrizador",
    "323": "Magmatizador",
    "324": "Disco Extraño",
    "325": "Tela Terrible",
    "326": "Garra Afilada",
    "327": "Colmillo Agudo",
    "328": "MT001",
    "329": "MT002",
    "330": "MT003",
    "331": "MT004",
    "332": "MT005",
    "333": "MT006",
    "334": "MT007",
    "335": "MT008",
    "336": "MT009",
    "337": "MT010",
    "338": "MT011",
    "339": "MT012",
    "340": "MT013",
    "341": "MT014",
    "342": "MT015",
    "343": "MT016",
    "344": "MT017",
    "345": "MT018",
    "346": "MT019",
    "347": "MT020",
    "348": "MT021",
    "349": "MT022",
    "350": "MT023",
    "351": "MT024",
    "352": "MT025",
    "353": "MT026",
    "354": "MT027",
    "355": "MT028",
    "356": "MT029",
    "357": "MT030",
    "358": "MT031",
    "359": "MT032",
    "360": "MT033",
    "361": "MT034",
    "362": "MT035",
    "363": "MT036",
    "364": "MT037",
    "365": "MT038",
    "366": "MT039",
    "367": "MT040",
    "368": "MT041",
    "369": "MT042",
    "370": "MT043",
    "371": "MT044",
    "372": "MT045",
    "373": "MT046",
    "374": "MT047",
    "375": "MT048",
    "376": "MT049",
    "377": "MT050",
    "378": "MT051",
    "379": "MT052",
    "380": "MT053",
    "381": "MT054",
    "382": "MT055",
    "383": "MT056",
    "384": "MT057",
    "385": "MT058",
    "386": "MT059",
    "387": "MT060",
    "388": "MT061",
    "389": "MT062",
    "390": "MT063",
    "391": "MT064",
    "392": "MT065",
    "393": "MT066",
    "394": "MT067",
    "395": "MT068",
    "396": "MT069",
    "397": "MT070",
    "398": "MT071",
    "399": "MT072",
    "400": "MT073",
    "401": "MT074",
    "402": "MT075",
    "403": "MT076",
    "404": "MT077",
    "405": "MT078",
    "406": "MT079",
    "407": "MT080",
    "408": "MT081",
    "409": "MT082",
    "410": "MT083",
    "411": "MT084",
    "412": "MT085",
    "413": "MT086",
    "414": "MT087",
    "415": "MT088",
    "416": "MT089",
    "417": "MT090",
    "418": "MT091",
    "419": "MT092",
    "426": "MT099",
    "427": "MT100",
    "428": "Kit de Explorador",
    "429": "Saca Botín",
    "430": "Reglamento",
    "432": "Tarjeta de Puntos",
    "433": "Guía de Viaje",
    "434": "Caja de Sellos",
    "435": "Caja Corazón",
    "436": "Bolsa de Sellos",
    "437": "Bloc de Amigos",
    "438": "Llave de la Central",
    "439": "Talismán",
    "441": "Cadena Roja",
    "443": "Buscapelea",
    "444": "Monedero",
    "448": "Psydugadera",
    "449": "Pokochera",
    "451": "Llave de la Suite",
    "452": "Carta Prof. Oak",
    "453": "Pluma Lunar",
    "454": "Carné de Socio",
    "455": "Flauta Azur",
    "456": "Ticket del Barco",
    "458": "Piedra Magma",
    "459": "Paquete",
    "460": "Cupón 1",
    "461": "Cupón 2",
    "462": "Cupón 3",
    "463": "Llave del Almacén",
    "464": "Medicina Secreta",
    "467": "Llave Secreta",
    "468": "Caja Bonguri",
    "469": "Bloc Unown",
    "470": "Plantabayas",
    "472": "Tarjeta Azul",
    "473": "Cola Slowpoke",
    "475": "Llave Magnética",
    "476": "Llave del Sótano",
    "477": "Squirgadera",
    "478": "Escama Roja",
    "479": "Objeto Perdido",
    "480": "Magnetopase",
    "481": "Maquinaria",
    "482": "Pluma Plateada",
    "483": "Pluma Arcoíris",
    "484": "Huevo Misterioso",
    "485": "Bonguri Rojo",
    "486": "Bonguri Azul",
    "487": "Bonguri Amarillo",
    "488": "Bonguri Verde",
    "489": "Bonguri Rosa",
    "490": "Bonguri Blanco",
    "491": "Bonguri Negro",
    "492": "Rapid Ball",
    "493": "Nivel Ball",
    "494": "Cebo Ball",
    "495": "Peso Ball",
    "496": "Amor Ball",
    "497": "Amigo Ball",
    "498": "Luna Ball",
    "499": "Competi Ball",
    "501": "Álbum",
    "502": "Reproductor GB",
    "504": "Caramelo Furia",
    "505": "Tarjeta Datos 01",
    "506": "Tarjeta Datos 02",
    "507": "Tarjeta Datos 03",
    "508": "Tarjeta Datos 04",
    "509": "Tarjeta Datos 05",
    "510": "Tarjeta Datos 06",
    "511": "Tarjeta Datos 07",
    "512": "Tarjeta Datos 08",
    "513": "Tarjeta Datos 09",
    "514": "Tarjeta Datos 10",
    "515": "Tarjeta Datos 11",
    "516": "Tarjeta Datos 12",
    "517": "Tarjeta Datos 13",
    "518": "Tarjeta Datos 14",
    "519": "Tarjeta Datos 15",
    "520": "Tarjeta Datos 16",
    "521": "Tarjeta Datos 17",
    "522": "Tarjeta Datos 18",
    "523": "Tarjeta Datos 19",
    "524": "Tarjeta Datos 20",
    "525": "Tarjeta Datos 21",
    "526": "Tarjeta Datos 22",
    "527": "Tarjeta Datos 23",
    "528": "Tarjeta Datos 24",
    "529": "Tarjeta Datos 25",
    "530": "Tarjeta Datos 26",
    "531": "Tarjeta Datos 27",
    "532": "Esfera Verde",
    "533": "Cápsula Candado",
    "534": "Prisma Rojo",
    "535": "Prisma Azul",
    "536": "Misticristal",
    "537": "Escama Bella",
    "538": "Mineral Evolutivo",
    "539": "Piedra Pómez",
    "540": "Casco Dentado",
    "541": "Globo Helio",
    "542": "Tarjeta Roja",
    "543": "Blanco",
    "544": "Banda Atadura",
    "545": "Tubérculo",
    "546": "Pila",
    "547": "Botón Escape",
    "548": "Gema Fuego",
    "549": "Gema Agua",
    "550": "Gema Eléctrico",
    "551": "Gema Planta",
    "552": "Gema Hielo",
    "553": "Gema Lucha",
    "554": "Gema Veneno",
    "555": "Gema Tierra",
    "556": "Gema Volador",
    "557": "Gema Psíquico",
    "558": "Gema Bicho",
    "559": "Gema Roca",
    "560": "Gema Fantasma",
    "561": "Gema Dragón",
    "562": "Gema Siniestro",
    "563": "Gema Acero",
    "564": "Gema Normal",
    "565": "Pluma Vigor",
    "566": "Pluma Músculo",
    "567": "Pluma Aguante",
    "568": "Pluma Intelecto",
    "569": "Pluma Mente",
    "570": "Pluma Ímpetu",
    "571": "Pluma Bella",
    "572": "Fósil Tapa",
    "573": "Fósil Pluma",
    "574": "Tarjeta Libertad",
    "575": "Regalosfera",
    "576": "Ensueño Ball",
    "577": "Pokéseñuelo",
    "578": "Neceser",
    "579": "Cráneo Dragón",
    "580": "Seta Aroma",
    "581": "Maxipepita",
    "582": "Sarta de Perlas",
    "583": "Fragmento Cometa",
    "584": "Real de Cobre",
    "585": "Real de Plata",
    "586": "Real de Oro",
    "587": "Ánfora Antigua",
    "588": "Brazal Antiguo",
    "589": "Efigie Antigua",
    "590": "Corona Antigua",
    "591": "Porcehelado",
    "592": "Crítico X 2",
    "593": "Velocidad X 2",
    "594": "Ataque Especial X 2",
    "595": "Defensa Especial X 2",
    "596": "Defensa X 2",
    "597": "Ataque X 2",
    "598": "Precisión X 2",
    "599": "Velocidad X 3",
    "600": "Ataque Especial X 3",
    "601": "Defensa Especial X 3",
    "602": "Defensa X 3",
    "603": "Ataque X 3",
    "604": "Precisión X 3",
    "605": "Velocidad X 6",
    "606": "Ataque Especial X 6",
    "607": "Defensa Especial X 6",
    "608": "Defensa X 6",
    "609": "Ataque X 6",
    "610": "Precisión X 6",
    "611": "Habilitador",
    "612": "Tiraobjeto",
    "613": "Activaobjeto",
    "614": "Quitaestado",
    "615": "Crítico X 3",
    "616": "Orbe Claro",
    "617": "Orbe Oscuro",
    "618": "MT093",
    "619": "MT094",
    "620": "MT095",
    "621": "Videomisor",
    "622": "(?)",
    "623": "Envío 1",
    "624": "Envío 2",
    "625": "Envío 3",
    "626": "Videomisor",
    "627": "Caja de Insignias",
    "630": "Pase",
    "633": "Tarjeta Plasma",
    "634": "Pañuelo Sucio",
    "635": "Acromáquina",
    "636": "Objeto Perdido",
    "637": "Objeto Perdido",
    "639": "Seguro Debilidad",
    "640": "Chaleco Asalto",
    "644": "Tabla Duende",
    "645": "Cápsula Habilidad",
    "646": "Dulce de Nata",
    "647": "Saquito Fragante",
    "648": "Musgo Brillante",
    "649": "Bola de Nieve",
    "650": "Gafa Protectora",
    "652": "Abono Fértil",
    "653": "Abono Sorpresa",
    "654": "Abono Fructífero",
    "655": "Abono Insólito",
    "656": "Gengarita",
    "657": "Gardevoirita",
    "658": "Ampharosita",
    "659": "Venusaurita",
    "660": "Charizardita X",
    "661": "Blastoisita",
    "662": "Mewtwoita X",
    "663": "Mewtwoita Y",
    "664": "Blazikenita",
    "665": "Medichamita",
    "666": "Houndoomita",
    "667": "Aggronita",
    "668": "Banettita",
    "669": "Tyranitarita",
    "670": "Scizorita",
    "671": "Pinsirita",
    "672": "Aerodactylita",
    "673": "Lucarita",
    "674": "Abomasnowita",
    "675": "Kangaskhanita",
    "676": "Gyaradosita",
    "677": "Absolita",
    "678": "Charizardita Y",
    "679": "Alakazamita",
    "680": "Heracrossita",
    "681": "Mawilita",
    "682": "Manectricita",
    "683": "Garchompita",
    "684": "Latiasita",
    "685": "Latiosita",
    "686": "Baya Hibis",
    "687": "Baya Biglia",
    "688": "Baya Maranga",
    "690": "MT096",
    "691": "MT097",
    "692": "MT098",
    "693": "MT099",
    "694": "MT100",
    "699": "Vale Descuento",
    "704": "Estatuilla Rara",
    "708": "Cr\u00eape Luminalia",
    "709": "Galleta Yantra",
    "710": "Fósil Mandíbula",
    "711": "Fósil Aleta",
    "715": "Gema Hada",
    "752": "Swampertita",
    "753": "Sceptilita",
    "754": "Sableynita",
    "755": "Altarianita",
    "756": "Galladita",
    "757": "Audinita",
    "758": "Metagrossita",
    "759": "Sharpedonita",
    "760": "Slowbronita",
    "761": "Steelixita",
    "762": "Pidgeotita",
    "763": "Glalita",
    "764": "Diancita",
    "767": "Cameruptita",
    "768": "Lopunnita",
    "769": "Salamencita",
    "770": "Beedrillita",
    "776": "Normastal Z",
    "777": "Pirostal Z",
    "778": "Hidrostal Z",
    "779": "Electrostal Z",
    "780": "Fitostal Z",
    "781": "Criostal Z",
    "782": "Lizastal Z",
    "783": "Toxistal Z",
    "784": "Geostal Z",
    "785": "Aerostal Z",
    "786": "Psicostal Z",
    "787": "Insectostal Z",
    "788": "Litostal Z",
    "789": "Espectrostal Z",
    "790": "Dracostal Z",
    "791": "Nictostal Z",
    "792": "Metalostal Z",
    "793": "Feeristal Z",
    "794": "Pikastal Z",
    "795": "Chapa Plateada",
    "796": "Chapa Dorada",
    "798": "Dueyestal Z",
    "799": "Incinostal Z",
    "800": "Primastal Z",
    "801": "Tapistal Z",
    "802": "Marshastal Z",
    "803": "Alo-Raistal Z",
    "804": "Snorlastal Z",
    "805": "Eeveestal Z",
    "806": "Mewstal Z",
    "807": "Normastal Z",
    "808": "Pirostal Z",
    "809": "Hidrostal Z",
    "810": "Electrostal Z",
    "811": "Fitostal Z",
    "812": "Criostal Z",
    "813": "Lizastal Z",
    "814": "Toxistal Z",
    "815": "Geostal Z",
    "816": "Aerostal Z",
    "817": "Psicostal Z",
    "818": "Insectostal Z",
    "819": "Litostal Z",
    "820": "Espectrostal Z",
    "821": "Dracostal Z",
    "822": "Nictostal Z",
    "823": "Metalostal Z",
    "824": "Feeristal Z",
    "825": "Pikastal Z",
    "826": "Dueyestal Z",
    "827": "Incinostal Z",
    "828": "Primastal Z",
    "829": "Tapistal Z",
    "830": "Marshastal Z",
    "831": "Alo-Raistal Z",
    "832": "Snorlastal Z",
    "833": "Eeveestal Z",
    "834": "Mewstal Z",
    "835": "Ash-Pikastal Z",
    "836": "Ash-Pikastal Z",
    "844": "Festicupón",
    "846": "Nerviosfera",
    "849": "Piedra Hielo",
    "851": "Ente Ball",
    "852": "Malasada Maxi",
    "853": "Néctar Rojo",
    "854": "Néctar Amarillo",
    "855": "Néctar Rosa",
    "856": "Néctar Violeta",
    "861": "Baya Frambu Plateada",
    "862": "Baya Frambu Dorada",
    "863": "Baya Latano Plateada",
    "864": "Baya Latano Dorada",
    "865": "Baya Pinia Plateada",
    "866": "Baya Pinia Dorada",
    "867": "(?)",
    "868": "(?)",
    "869": "(?)",
    "870": "(?)",
    "871": "(?)",
    "879": "Cubresuelos",
    "880": "Paracontacto",
    "881": "Semilla Electro",
    "882": "Semilla Psique",
    "883": "Semilla Bruma",
    "884": "Semilla Hierba",
    "885": "Muelle Estirado",
    "886": "Tiza",
    "887": "Canica",
    "888": "Pendiente",
    "889": "Cristal Marino",
    "890": "Hoja de Oro",
    "891": "Hoja de Plata",
    "892": "Bola de Arcilla",
    "893": "Concha Tropical",
    "894": "Hoja Escrita",
    "895": "Hoja Escrita",
    "896": "Ramo Pequeño",
    "897": "(?)",
    "898": "(?)",
    "899": "(?)",
    "900": "Colonia",
    "901": "Supercolonia",
    "902": "Colonia Máxima",
    "903": "Rokikos",
    "904": "Disco Lucha",
    "905": "Disco Volador",
    "906": "Disco Veneno",
    "907": "Disco Tierra",
    "908": "Disco Roca",
    "909": "Disco Bicho",
    "910": "Disco Fantasma",
    "911": "Disco Acero",
    "912": "Disco Fuego",
    "913": "Disco Agua",
    "914": "Disco Planta",
    "915": "Disco Eléctrico",
    "916": "Disco Psíquico",
    "917": "Disco Hielo",
    "918": "Disco Dragón",
    "919": "Disco Siniestro",
    "920": "Disco Hada",
    "921": "Solgaleostal Z",
    "922": "Lunalastal Z",
    "923": "Ultranecrostal Z",
    "924": "Mimikyustal Z",
    "925": "Lycanrostal Z",
    "926": "Kommostal Z",
    "927": "Solgaleostal Z",
    "928": "Lunalastal Z",
    "929": "Ultranecrostal Z",
    "930": "Mimikyustal Z",
    "931": "Lycanrostal Z",
    "932": "Kommostal Z",
    "949": "Cupón Eclosión",
    "950": "Cupón Rebaja",
    "951": "Cupón Botín",
    "952": "Cupón Exp",
    "953": "Cupón Amistad",
    "954": "Cupón Reclamo",
    "955": "Cupón Sigilo",
    "956": "Cupón PS",
    "957": "Cupón PP",
    "958": "Cupón Refuerzo",
    "959": "Cupón Captura",
    "960": "Caramelo Vigor",
    "961": "Caramelo Músculo",
    "962": "Caramelo Aguante",
    "963": "Caramelo Intelecto",
    "964": "Caramelo Mente",
    "965": "Caramelo Ímpetu",
    "966": "Caramelo Vigor +",
    "967": "Caramelo Músculo +",
    "968": "Caramelo Aguante +",
    "969": "Caramelo Intelecto +",
    "970": "Caramelo Mente +",
    "971": "Caramelo Ímpetu +",
    "972": "Caramelo Vigor ++",
    "973": "Caramelo Músculo ++",
    "974": "Caramelo Aguante ++",
    "975": "Caramelo Intelecto ++",
    "976": "Caramelo Mente ++",
    "977": "Caramelo Ímpetu ++",
    "978": "Caramelo Bulbasaur",
    "979": "Caramelo Charmander",
    "980": "Caramelo Squirtle",
    "981": "Caramelo Caterpie",
    "982": "Caramelo Weedle",
    "983": "Caramelo Pidgey",
    "984": "Caramelo Rattata",
    "985": "Caramelo Spearow",
    "986": "Caramelo Ekans",
    "987": "Caramelo Pikachu",
    "988": "Caramelo Sandshrew",
    "989": "Caramelo Nidoran[Character1:female ]",
    "990": "Caramelo Nidoran[Character1:male ]",
    "991": "Caramelo Clefairy",
    "992": "Caramelo Vulpix",
    "993": "Caramelo Jigglypuff",
    "994": "Caramelo Zubat",
    "995": "Caramelo Oddish",
    "996": "Caramelo Paras",
    "997": "Caramelo Venonat",
    "998": "Caramelo Diglett",
    "999": "Caramelo Meowth",
    "1000": "Caramelo Psyduck",
    "1001": "Caramelo Mankey",
    "1002": "Caramelo Growlithe",
    "1003": "Caramelo Poliwag",
    "1004": "Caramelo Abra",
    "1005": "Caramelo Machop",
    "1006": "Caramelo Bellsprout",
    "1007": "Caramelo Tentacool",
    "1008": "Caramelo Geodude",
    "1009": "Caramelo Ponyta",
    "1010": "Caramelo Slowpoke",
    "1011": "Caramelo Magnemite",
    "1012": "Caramelo Farfetch'd",
    "1013": "Caramelo Doduo",
    "1014": "Caramelo Seel",
    "1015": "Caramelo Grimer",
    "1016": "Caramelo Shellder",
    "1017": "Caramelo Gastly",
    "1018": "Caramelo Onix",
    "1019": "Caramelo Drowzee",
    "1020": "Caramelo Krabby",
    "1021": "Caramelo Voltorb",
    "1022": "Caramelo Exeggcute",
    "1023": "Caramelo Cubone",
    "1024": "Caramelo Hitmonlee",
    "1025": "Caramelo Hitmonchan",
    "1026": "Caramelo Lickitung",
    "1027": "Caramelo Koffing",
    "1028": "Caramelo Rhyhorn",
    "1029": "Caramelo Chansey",
    "1030": "Caramelo Tangela",
    "1031": "Caramelo Kangaskhan",
    "1032": "Caramelo Horsea",
    "1033": "Caramelo Goldeen",
    "1034": "Caramelo Staryu",
    "1035": "Caramelo Mr. Mime",
    "1036": "Caramelo Scyther",
    "1037": "Caramelo Jynx",
    "1038": "Caramelo Electabuzz",
    "1039": "Caramelo Pinsir",
    "1040": "Caramelo Tauros",
    "1041": "Caramelo Magikarp",
    "1042": "Caramelo Lapras",
    "1043": "Caramelo Ditto",
    "1044": "Caramelo Eevee",
    "1045": "Caramelo Porygon",
    "1046": "Caramelo Omanyte",
    "1047": "Caramelo Kabuto",
    "1048": "Caramelo Aerodactyl",
    "1049": "Caramelo Snorlax",
    "1050": "Caramelo Articuno",
    "1051": "Caramelo Zapdos",
    "1052": "Caramelo Moltres",
    "1053": "Caramelo Dratini",
    "1054": "Caramelo Mewtwo",
    "1055": "Caramelo Mew",
    "1056": "Caramelo Meltan",
    "1057": "Caramelo Magmar",
    "1058": "(?)",
    "1059": "(?)",
    "1060": "(?)",
    "1061": "(?)",
    "1062": "(?)",
    "1063": "(?)",
    "1064": "(?)",
    "1065": "(?)",
    "1066": "(?)",
    "1067": "(?)",
    "1068": "(?)",
    "1069": "(?)",
    "1070": "(?)",
    "1071": "(?)",
    "1072": "(?)",
    "1073": "(?)",
    "1084": "Salchichas",
    "1085": "Lata de Darren",
    "1086": "Lata de Bach",
    "1087": "Lata de Habas",
    "1088": "Pan de Molde",
    "1089": "Pasta",
    "1090": "Setas",
    "1091": "Cola Ahumada",
    "1092": "Puerro Grueso",
    "1093": "Manzana Selecta",
    "1094": "Huesos Finos",
    "1095": "Patatas",
    "1096": "Hierba Intensa",
    "1097": "Verduras",
    "1098": "Frituras",
    "1099": "Huevo Duro",
    "1103": "Espada Oxidada",
    "1104": "Escudo Oxidado",
    "1105": "Ornitofósil",
    "1106": "Ictiofósil",
    "1107": "Dracofósil",
    "1108": "Plesiofósil",
    "1109": "Confite Fresa",
    "1110": "Confite Corazón",
    "1111": "Confite Fruto",
    "1112": "Confite Trébol",
    "1113": "Confite Flor",
    "1114": "Confite Estrella",
    "1115": "Confite Lazo",
    "1116": "Manzana Dulce",
    "1117": "Manzana Ácida",
    "1118": "Espray Bucal",
    "1119": "Mochila Escape",
    "1120": "Botas Gruesas",
    "1121": "Seguro Fallo",
    "1122": "Servicio Raro",
    "1123": "Parasol Multiuso",
    "1124": "Caramelo Exp. XS",
    "1125": "Caramelo Exp. S",
    "1126": "Caramelo Exp. M",
    "1127": "Caramelo Exp. L",
    "1128": "Caramelo Exp. XL",
    "1129": "Caramelo Dinamax",
    "1130": "DT00",
    "1131": "DT01",
    "1132": "DT02",
    "1133": "DT03",
    "1134": "DT04",
    "1135": "DT05",
    "1136": "DT06",
    "1137": "DT07",
    "1138": "DT08",
    "1139": "DT09",
    "1140": "DT10",
    "1141": "DT11",
    "1142": "DT12",
    "1143": "DT13",
    "1144": "DT14",
    "1145": "DT15",
    "1146": "DT16",
    "1147": "DT17",
    "1148": "DT18",
    "1149": "DT19",
    "1150": "DT20",
    "1151": "DT21",
    "1152": "DT22",
    "1153": "DT23",
    "1154": "DT24",
    "1155": "DT25",
    "1156": "DT26",
    "1157": "DT27",
    "1158": "DT28",
    "1159": "DT29",
    "1160": "DT30",
    "1161": "DT31",
    "1162": "DT32",
    "1163": "DT33",
    "1164": "DT34",
    "1165": "DT35",
    "1166": "DT36",
    "1167": "DT37",
    "1168": "DT38",
    "1169": "DT39",
    "1170": "DT40",
    "1171": "DT41",
    "1172": "DT42",
    "1173": "DT43",
    "1174": "DT44",
    "1175": "DT45",
    "1176": "DT46",
    "1177": "DT47",
    "1178": "DT48",
    "1179": "DT49",
    "1180": "DT50",
    "1181": "DT51",
    "1182": "DT52",
    "1183": "DT53",
    "1184": "DT54",
    "1185": "DT55",
    "1186": "DT56",
    "1187": "DT57",
    "1188": "DT58",
    "1189": "DT59",
    "1190": "DT60",
    "1191": "DT61",
    "1192": "DT62",
    "1193": "DT63",
    "1194": "DT64",
    "1195": "DT65",
    "1196": "DT66",
    "1197": "DT67",
    "1198": "DT68",
    "1199": "DT69",
    "1200": "DT70",
    "1201": "DT71",
    "1202": "DT72",
    "1203": "DT73",
    "1204": "DT74",
    "1205": "DT75",
    "1206": "DT76",
    "1207": "DT77",
    "1208": "DT78",
    "1209": "DT79",
    "1210": "DT80",
    "1211": "DT81",
    "1212": "DT82",
    "1213": "DT83",
    "1214": "DT84",
    "1215": "DT85",
    "1216": "DT86",
    "1217": "DT87",
    "1218": "DT88",
    "1219": "DT89",
    "1220": "DT90",
    "1221": "DT91",
    "1222": "DT92",
    "1223": "DT93",
    "1224": "DT94",
    "1225": "DT95",
    "1226": "DT96",
    "1227": "DT97",
    "1228": "DT98",
    "1229": "DT99",
    "1230": "MT00",
    "1231": "Menta Huraña",
    "1232": "Menta Firme",
    "1233": "Menta Pícara",
    "1234": "Menta Audaz",
    "1235": "Menta Osada",
    "1236": "Menta Agitada",
    "1237": "Menta Floja",
    "1238": "Menta Plácida",
    "1239": "Menta Modesta",
    "1240": "Menta Afable",
    "1241": "Menta Alocada",
    "1242": "Menta Mansa",
    "1243": "Menta Serena",
    "1244": "Menta Amable",
    "1245": "Menta Cauta",
    "1246": "Menta Grosera",
    "1247": "Menta Miedosa",
    "1248": "Menta Activa",
    "1249": "Menta Alegre",
    "1250": "Menta Ingenua",
    "1251": "Menta Seria",
    "1252": "Trozo Deseo",
    "1253": "Tetera Agrietada",
    "1254": "Tetera Rota",
    "1256": "Fruta Tropical",
    "1257": "Queso Mu-mu",
    "1258": "Especias",
    "1259": "Nata Fresca",
    "1260": "Curri de Bote",
    "1261": "Leche de Coco",
    "1262": "Fideos de Bote",
    "1263": "Hamburguesas",
    "1264": "Especias Gigamax",
    "1265": "Trocito Deseo",
    "1268": "(?)",
    "1579": "Maxipanal",
    "1580": "Maxiseta",
    "1581": "Rama de Galanuez",
    "1582": "Brazal Galanuez",
    "1588": "Duralium",
    "1592": "Corona Galanuez",
    "1604": "Maxinium",
    "1606": "Parche Habilidad",
    "1608": "Calmasfera Tiempo",
    "1609": "Calmasfera Espacio",
    "1610": "Calmasfera",
    "1611": "Cordón Unión",
    "1612": "Bizcocho Clásico",
    "1613": "Bonguri",
    "1614": "Bizcocho Jubileo",
    "1615": "Gragea Multi",
    "1616": "Gragea Crítica",
    "1617": "Aperitivo Elección",
    "1618": "Encurtidoble",
    "1619": "Bocadito Inversión",
    "1620": "Helecho Rizado",
    "1621": "Semilla Dominio",
    "1622": "Poké Ball",
    "1623": "(?)",
    "1624": "Hielo Eterno",
    "1625": "Garra de Uxie",
    "1626": "Diente de Azelf",
    "1627": "Pluma de Mesprit",
    "1628": "Guijarro Rojo",
    "1629": "Flauta Celestial",
    "1630": "Remedio",
    "1631": "Superremedio",
    "1632": "Miel Brillante",
    "1633": "Espiga Vivaz",
    "1634": "Haba Suculenta",
    "1635": "Seta Esponjosa",
    "1636": "Mineral Crocante",
    "1637": "Madera",
    "1638": "Hierba Regia",
    "1639": "Calmasfera Pantano",
    "1640": "Poké Ball",
    "1641": "Super Ball",
    "1642": "Ultra Ball",
    "1643": "Pluma Ball",
    "1644": "Pokémuñeca",
    "1645": "(?)",
    "1646": "Bola Humareda",
    "1647": "Bola Ruidosa",
    "1648": "Bola Pegajosa",
    "1649": "Trozo Estrella",
    "1650": "Cebo de Setas",
    "1651": "Hierba Repelente",
    "1652": "Cebo Meloso",
    "1653": "Cebo de Grano",
    "1654": "Cebo de Habas",
    "1655": "Cebo Mineral",
    "1656": "Poción",
    "1657": "Superpoción",
    "1658": "Hiperpoción",
    "1659": "Poción Máxima",
    "1660": "Restaurar Todo",
    "1661": "Remedio",
    "1662": "Superremedio",
    "1663": "Hiperremedio",
    "1664": "Barrita Plus",
    "1665": "Bizcocho Jubileo",
    "1666": "Cura Total",
    "1667": "Revivir",
    "1668": "Revivir Máximo",
    "1669": "Píldora Éter",
    "1670": "Píldora Elixir",
    "1671": "Aerosol Sigilo",
    "1672": "(?)",
    "1673": "Gragea Ofensiva",
    "1674": "Gragea Defensiva",
    "1675": "Gragea Crítica",
    "1676": "Gragea Evasiva",
    "1677": "Gragea Multi",
    "1678": "Calmasfera Bosque",
    "1679": "Pepita de Hierro",
    "1680": "(?)",
    "1681": "Guijarro Negro",
    "1682": "Guijarro Celeste",
    "1683": "(?)",
    "1684": "Bola de Lodo",
    "1685": "(?)",
    "1686": "Marimo Ruidoso",
    "1687": "Fumibulbo",
    "1688": "Bonguri Pocho",
    "1689": "Bola de Nieve",
    "1690": "Bola Pegajosa",
    "1691": "Mineral Negro",
    "1692": "Bloque de Turba",
    "1693": "Aerosol Sigilo",
    "1694": "Puerro Medicinal",
    "1695": "Revibrote",
    "1696": "Hierba Éter",
    "1697": "(?)",
    "1698": "(?)",
    "1699": "Amuleto Sustituto 2",
    "1700": "Amuleto Sustituto 3",
    "1701": "Seta Espada",
    "1702": "Seta Férrea",
    "1703": "Seta Evasiva",
    "1704": "Seta Crítica",
    "1705": "Rábano Arenero",
    "1706": "Amuleto Sustituto 4",
    "1707": "Amuleto Sustituto 5",
    "1708": "Trufa Dulce",
    "1709": "Masa para Cebo",
    "1710": "Poké Ball",
    "1711": "Super Ball",
    "1712": "Ultra Ball",
    "1713": "Pluma Ball",
    "1714": "(?)",
    "1715": "(?)",
    "1716": "Bola Ruidosa",
    "1717": "Bola Humareda",
    "1718": "(?)",
    "1719": "(?)",
    "1720": "Pokémuñeca",
    "1721": "Calmasfera Volcán",
    "1722": "Calmasfera Montaña",
    "1723": "Calmasfera Nieve",
    "1724": "Cebo Meloso",
    "1725": "Cebo de Grano",
    "1726": "Cebo de Habas",
    "1727": "Cebo de Setas",
    "1728": "Cebo Mineral",
    "1729": "Bocadito Inversión",
    "1730": "Aperitivo Elección",
    "1731": "Encurtidoble",
    "1732": "Amuleto Protector 1",
    "1733": "Amuleto Protector 2",
    "1734": "Amuleto Protector 3",
    "1735": "Amuleto Protector 4",
    "1736": "Amuleto Protector 5",
    "1737": "Diario Rasgado",
    "1738": "Amuleto Salud 1",
    "1739": "Amuleto Salud 2",
    "1740": "Amuleto Salud 3",
    "1741": "Amuleto Salud 4",
    "1742": "Amuleto Salud 5",
    "1743": "Trozo de Losa",
    "1744": "Cebo Basculegion",
    "1745": "Diario Antiguo",
    "1746": "Ala Ball",
    "1747": "Aero Ball",
    "1748": "Peso Ball",
    "1749": "Kilo Ball",
    "1750": "Quintal Ball",
    "1751": "Ala Ball",
    "1752": "Aero Ball",
    "1753": "Peso Ball",
    "1754": "Baya Lupu",
    "1755": "Hiperremedio",
    "1756": "Gragea Ofensiva",
    "1757": "Gragea Defensiva",
    "1758": "Gragea Evasiva",
    "1759": "Polvo Esfuerzo",
    "1760": "Grava Esfuerzo",
    "1761": "Piedra Esfuerzo",
    "1762": "Roca Esfuerzo",
    "1763": "Medicina Secreta",
    "1764": "Amuleto Sustituto 1",
    "1765": "Objeto perdido",
    "1766": "Objeto perdido",
    "1767": "Objeto perdido",
    "1768": "Objeto perdido",
    "1769": "Objeto perdido",
    "1770": "(?)",
    "1771": "Origen Ball",
    "1772": "(?)",
    "1773": "(?)",
    "1774": "(?)",
    "1775": "(?)",
    "1776": "Mena Origen",
    "1777": "Gran Diamansfera",
    "1778": "Gran Lustresfera",
    "1779": "Gran Griseosfera",
    "1780": "Tabla Neutra",
    "1781": "(?)",
    "1782": "Kit de Artesanía",
    "1783": "Kilo Ball",
    "1784": "Quintal Ball",
    "1785": "Extraña Ball",
    "1786": "Pokédex",
    "1787": "Poema Antiguo 1",
    "1788": "Poema Antiguo 2",
    "1789": "Poema Antiguo 3",
    "1790": "Poema Antiguo 4",
    "1791": "(?)",
    "1792": "Poema Antiguo 5",
    "1793": "Poema Antiguo 6",
    "1794": "Poema Antiguo 7",
    "1795": "Poema Antiguo 8",
    "1796": "Poema Antiguo 9",
    "1797": "Poema Antiguo 10",
    "1798": "Poema Antiguo 11",
    "1799": "Poema Antiguo 12",
    "1800": "Poema Antiguo 13",
    "1801": "Poema Antiguo 14",
    "1802": "Poema Antiguo 15",
    "1803": "Poema Antiguo 16",
    "1804": "Poema Antiguo 17",
    "1805": "Poema Antiguo 18",
    "1806": "Poema Antiguo 19",
    "1807": "Poema Antiguo 20",
    "1808": "Esquirla Extraña S",
    "1809": "Esquirla Extraña L",
    "1810": "Taladro",
    "1811": "Losa Kanto",
    "1812": "Losa Johto",
    "1813": "Losa Empatía",
    "1814": "Losa Arcoíris",
    "1815": "Losa Tormenta",
    "1816": "Losa Mar",
    "1817": "Losa Tierra",
    "1818": "Losa Cielo",
    "1819": "Losa Genética",
    "1820": "Losa Inicio",
    "1821": "Losa Distorsión",
    "1822": "Reproductor DS",
    "1828": "Tabla Legendaria",
    "1842": "Bambú Pequeño",
    "1843": "Bambú Grande",
    "1861": "Armadura Maldita",
    "1862": "Teralito Normal",
    "1863": "Teralito Fuego",
    "1864": "Teralito Agua",
    "1865": "Teralito Eléctrico",
    "1866": "Teralito Planta",
    "1867": "Teralito Hielo",
    "1868": "Teralito Lucha",
    "1869": "Teralito Veneno",
    "1870": "Teralito Tierra",
    "1871": "Teralito Volador",
    "1872": "Teralito Psíquico",
    "1873": "Teralito Bicho",
    "1874": "Teralito Roca",
    "1875": "Teralito Fantasma",
    "1876": "Teralito Dragón",
    "1877": "Teralito Siniestro",
    "1878": "Teralito Acero",
    "1879": "Teralito Hada",
    "1880": "Energía Potenciadora",
    "1881": "Escudo Habilidad",
    "1882": "Amuleto Puro",
    "1883": "Hierba Copia",
    "1884": "Guante de Boxeo",
    "1885": "Capa Furtiva",
    "1886": "Dado Trucado",
    "2160": "MT100",
    "2161": "MT101",
    "2162": "MT102",
    "2163": "MT103",
    "2164": "MT104",
    "2165": "MT105",
    "2166": "MT106",
    "2167": "MT107",
    "2168": "MT108",
    "2169": "MT109",
    "2170": "MT110",
    "2171": "MT111",
    "2172": "MT112",
    "2173": "MT113",
    "2174": "MT114",
    "2175": "MT115",
    "2176": "MT116",
    "2177": "MT117",
    "2178": "MT118",
    "2179": "MT119",
    "2180": "MT120",
    "2181": "MT121",
    "2182": "MT122",
    "2183": "MT123",
    "2184": "MT124",
    "2185": "MT125",
    "2186": "MT126",
    "2187": "MT127",
    "2188": "MT128",
    "2189": "MT129",
    "2190": "MT130",
    "2191": "MT131",
    "2192": "MT132",
    "2193": "MT133",
    "2194": "MT134",
    "2195": "MT135",
    "2196": "MT136",
    "2197": "MT137",
    "2198": "MT138",
    "2199": "MT139",
    "2200": "MT140",
    "2201": "MT141",
    "2202": "MT142",
    "2203": "MT143",
    "2204": "MT144",
    "2205": "MT145",
    "2206": "MT146",
    "2207": "MT147",
    "2208": "MT148",
    "2209": "MT149",
    "2210": "MT150",
    "2211": "MT151",
    "2212": "MT152",
    "2213": "MT153",
    "2214": "MT154",
    "2215": "MT155",
    "2216": "MT156",
    "2217": "MT157",
    "2218": "MT158",
    "2219": "MT159",
    "2220": "MT160",
    "2221": "MT161",
    "2222": "MT162",
    "2223": "MT163",
    "2224": "MT164",
    "2225": "MT165",
    "2226": "MT166",
    "2227": "MT167",
    "2228": "MT168",
    "2229": "MT169",
    "2230": "MT170",
    "2231": "MT171",
    "2232": "MT172",
    "2233": "MT173",
    "2234": "MT174",
    "2235": "MT175",
    "2236": "MT176",
    "2237": "MT177",
    "2238": "MT178",
    "2239": "MT179",
    "2240": "MT180",
    "2241": "MT181",
    "2242": "MT182",
    "2243": "MT183",
    "2244": "MT184",
    "2245": "MT185",
    "2246": "MT186",
    "2247": "MT187",
    "2248": "MT188",
    "2249": "MT189",
    "2250": "MT190",
    "2251": "MT191",
    "2252": "MT192",
    "2253": "MT193",
    "2254": "MT194",
    "2255": "MT195",
    "2256": "MT196",
    "2257": "MT197",
    "2258": "MT198",
    "2259": "MT199",
    "2260": "MT200",
    "2261": "MT201",
    "2262": "MT202",
    "2263": "MT203",
    "2264": "MT204",
    "2265": "MT205",
    "2266": "MT206",
    "2267": "MT207",
    "2268": "MT208",
    "2269": "MT209",
    "2270": "MT210",
    "2271": "MT211",
    "2272": "MT212",
    "2273": "MT213",
    "2274": "MT214",
    "2275": "MT215",
    "2276": "MT216",
    "2277": "MT217",
    "2278": "MT218",
    "2279": "MT219",
    "2280": "MT220",
    "2281": "MT221",
    "2282": "MT222",
    "2283": "MT223",
    "2284": "MT224",
    "2285": "MT225",
    "2286": "MT226",
    "2287": "MT227",
    "2288": "MT228",
    "2289": "MT229",
    "2344": "Armadura Auspiciosa",
    "2345": "Distintivo de Líder",
    "2401": "Pluma Feérica",
    "2402": "Manzana Melosa",
    "2403": "Cuenco Mediocre",
    "2404": "Cuenco Exquisito",
    "2405": "Máscara Turquesa",
    "2406": "Máscara Cimiento",
    "2407": "Máscara Fuente",
    "2408": "Máscara Horno",
    "2409": "Tarjeta Chic Verde",
    "2410": "Fragmento de Cristal",
    "2411": "Mochi Vigor",
    "2412": "Mochi Músculo",
    "2413": "Mochi Aguante",
    "2414": "Mochi Intelecto",
    "2415": "Mochi Mente",
    "2416": "Mochi Ímpetu",
    "2417": "Sillas Simples",
    "2418": "Sillas Academia",
    "2419": "Sillas Academia",
    "2420": "Sillas Cucas",
    "2421": "Sillas Naturaleza",
    "2422": "Sillas Espectrales",
    "2423": "Sillas Cuadros Ámbares",
    "2424": "Sillas Cuadros Azules",
    "2425": "Sillas Cuadros Rojas",
    "2426": "Sillas Hierba Alta",
    "2427": "Sillas Combate",
    "2428": "Sillas Monstruosas",
    "2429": "Sillas Rayas",
    "2430": "Sillas Rombos",
    "2431": "Sillas Lunares",
    "2432": "Sillas Malvas",
    "2433": "Sillas Menta",
    "2434": "Sillas Beis",
    "2435": "Sillas Amarillas",
    "2436": "Sillas Azules",
    "2437": "Sillas Rosas",
    "2438": "Colmillo de Ekans",
    "2439": "Garra de Sandshrew",
    "2440": "Pelo de Cleffa",
    "2441": "Pelo de Vulpix",
    "2442": "Secreción de Poliwag",
    "2443": "Liana de Bellsprout",
    "2444": "Fragmento de Geodude",
    "2445": "Gas de Koffing",
    "2446": "Colmillo de Munchlax",
    "2447": "Pelo de Sentret",
    "2448": "Pluma de Hoothoot",
    "2449": "Hilo de Spinarak",
    "2450": "Pelo de Aipom",
    "2451": "Aguijón de Yanma",
    "2452": "Colmillo de Gligar",
    "2453": "Lava de Slugma",
    "2454": "Pelo de Swinub",
    "2455": "Colmillo de Poochyena",
    "2456": "Hoja de Lotad",
    "2457": "Tallo de Seedot",
    "2458": "Fragmento de Nosepass",
    "2459": "Fluido de Volbeat",
    "2460": "Fluido de Illumise",
    "2461": "Cáscara de Corphish",
    "2462": "Escama de Feebas",
    "2463": "Fragmento de Duskull",
    "2464": "Fragmento de Chingling",
    "2465": "Sudor de Timburr",
    "2466": "Hoja de Sewaddle",
    "2467": "Pluma de Ducklett",
    "2468": "Hollín de Litwick",
    "2469": "Garra de Mienfoo",
    "2470": "Pluma de Vullaby",
    "2471": "Gema de Carbink",
    "2472": "Rama de Phantump",
    "2473": "Hilo de Grubbin",
    "2474": "Polvo de Cutiefly",
    "2475": "Escama de Jangmo-o",
    "2476": "Plumón de Cramorant",
    "2477": "Semilla de Morpeko",
    "2478": "Polvo de Poltchageist",
    "2479": "Mochi Reinicio",
    "2480": "Paloselfi Rotom",
    "2481": "Amuleto Cristalino",
    "2482": "Metal Compuesto",
    "2483": "Tarjeta Chic Azul",
    "2484": "Hoja de Oddish",
    "2485": "Aguijón de Tentacool",
    "2486": "Plumón de Doduo",
    "2487": "Pelo de Seel",
    "2488": "Cáscara de Exeggcute",
    "2489": "Sudor de Tyrogue",
    "2490": "Colmillo de Rhyhorn",
    "2491": "Tinta de Horsea",
    "2492": "Pelo de Elekid",
    "2493": "Pelo de Magby",
    "2494": "Lágrima de Lapras",
    "2495": "Fragmento de Porygon",
    "2496": "Electricidad de Chinchou",
    "2497": "Pelo de Snubbull",
    "2498": "Pluma de Skarmory",
    "2499": "Pintura de Smeargle",
    "2500": "Pelo de Plusle",
    "2501": "Pelo de Minun",
    "2502": "Coraza de Trapinch",
    "2503": "Garra de Beldum",
    "2504": "Púa de Cranidos",
    "2505": "Garra de Shieldon",
    "2506": "Mechón de Blitzle",
    "2507": "Garra de Drilbur",
    "2508": "Algodón de Cottonee",
    "2509": "Sudor de Scraggy",
    "2510": "Pelo de Minccino",
    "2511": "Gel de Solosis",
    "2512": "Hilo de Joltik",
    "2513": "Fragmento de Golett",
    "2514": "Pelo de Espurr",
    "2515": "Tinta de Inkay",
    "2516": "Pluma de Pikipek",
    "2517": "Hilo de Dewpider",
    "2518": "Flor de Comfey",
    "2519": "Caparazón de Minior",
    "2520": "Nata de Milcery",
    "2521": "\u00d3xido de Duraludon",
    "2522": "Galleta Articuno",
    "2523": "Galleta Zapdos",
    "2524": "Galleta Moltres",
    "2525": "Galleta Raikou",
    "2526": "Galleta Entei",
    "2527": "Galleta Suicune",
    "2528": "Galleta Lugia",
    "2529": "Galleta Ho-Oh",
    "2530": "Galleta Latias",
    "2531": "Galleta Latios",
    "2532": "Galleta Kyogre",
    "2533": "Galleta Groudon",
    "2534": "Galleta Rayquaza",
    "2535": "Galleta Cobalion",
    "2536": "Galleta Terrakion",
    "2537": "Galleta Virizion",
    "2538": "Galleta Reshiram",
    "2539": "Galleta Zekrom",
    "2540": "Galleta Kyurem",
    "2541": "Galleta Solgaleo",
    "2542": "Galleta Lunala",
    "2543": "Galleta Necrozma",
    "2544": "Galleta Kubfu",
    "2545": "Galleta Glastrier",
    "2546": "Galleta Spectrier",
    "2547": "Disco Índigo",
    "2548": "Palillo Ígneo",
    "2549": "Teralito Astral",
    "2550": "Chesnaughtite",
    "2551": "Clefablite",
    "2552": "Delphoxite",
    "2553": "Dragoninite",
    "2554": "Drampanite",
    "2555": "Emboarite",
    "2556": "Excadrillite",
    "2557": "Feraligite",
    "2558": "Floettite",
    "2559": "Greninjite",
    "2560": "Golurkite",
    "2561": "Hawluchanite",
    "2562": "Meganiumite",
    "2563": "Meowsticite",
    "2564": "Starmiite",
    "2565": "Victreebelite",
    "2566": "Skarmoryite",
    "2567": "Chandelurite",
    "2568": "Zygardite",
    "2569": "Glimmoranite",
    "2570": "Crabominite",
    "2571": "Raichuite X",
    "2572": "Raichuite Y",
    "2573": "Chimechite",
    "2574": "Absolite Z",
    "2575": "Staraptorite",
    "2576": "Garchompite Z",
    "2577": "Lucarionite Z",
    "2578": "Heatranite",
    "2579": "Darkranite",
    "2580": "Golisopite",
    "2581": "Magearnite",
    "2582": "Zeraorite",
    "2583": "Scovillainite",
    "2584": "Tatsugirite",
    "2585": "Baxcalibrite"
}
export default itemsEs;